<header hsg-header [sectionLinks]="sectionLinks" [applicationLinks]="sectionLinks"></header>
<nav hsg-sub-nav [hidden]="!showNav"></nav>

<main smtGAEventTracker>
  <router-outlet></router-outlet>

  <smt-session-model [(isActive)]="sessionExpiring" (acceptEvent)="extendSession()" (rejectEvent)="extendSession()"
  [disableFooter]="false" [disableHeader]="false" acceptText="Keep Working">
  <div role="body" class="txt-font">
      {{sessionMessage}}
  </div>
</smt-session-model>

</main>

<footer hsg-footer></footer>